/**
 * Animated bird-themed SVG icons (replaces @heroicons/react/24/outline).
 * Auto-mapped via Vite alias.
 */
import { createBirdHeroicon } from './createIcon';
export const AcademicCapIcon = createBirdHeroicon('AcademicCapIcon');
export const AdjustmentsHorizontalIcon = createBirdHeroicon('AdjustmentsHorizontalIcon');
export const ArchiveBoxIcon = createBirdHeroicon('ArchiveBoxIcon');
export const ArrowDownIcon = createBirdHeroicon('ArrowDownIcon');
export const ArrowDownTrayIcon = createBirdHeroicon('ArrowDownTrayIcon');
export const ArrowPathIcon = createBirdHeroicon('ArrowPathIcon');
export const ArrowRightIcon = createBirdHeroicon('ArrowRightIcon');
export const ArrowLeftOnRectangleIcon = createBirdHeroicon('ArrowLeftOnRectangleIcon');
export const ArrowRightOnRectangleIcon = createBirdHeroicon('ArrowRightOnRectangleIcon');
export const ArrowsRightLeftIcon = createBirdHeroicon('ArrowsRightLeftIcon');
export const ArrowsUpDownIcon = createBirdHeroicon('ArrowsUpDownIcon');
export const ArrowTrendingDownIcon = createBirdHeroicon('ArrowTrendingDownIcon');
export const ArrowTrendingUpIcon = createBirdHeroicon('ArrowTrendingUpIcon');
export const ArrowUpIcon = createBirdHeroicon('ArrowUpIcon');
export const ArrowUpTrayIcon = createBirdHeroicon('ArrowUpTrayIcon');
export const BanknotesIcon = createBirdHeroicon('BanknotesIcon');
export const Bars3Icon = createBirdHeroicon('Bars3Icon');
export const BeakerIcon = createBirdHeroicon('BeakerIcon');
export const BellIcon = createBirdHeroicon('BellIcon');
export const BoltIcon = createBirdHeroicon('BoltIcon');
export const BookmarkIcon = createBirdHeroicon('BookmarkIcon');
export const BookOpenIcon = createBirdHeroicon('BookOpenIcon');
export const BuildingLibraryIcon = createBirdHeroicon('BuildingLibraryIcon');
export const BuildingOffice2Icon = createBirdHeroicon('BuildingOffice2Icon');
export const BuildingOfficeIcon = createBirdHeroicon('BuildingOfficeIcon');
export const BuildingStorefrontIcon = createBirdHeroicon('BuildingStorefrontIcon');
export const CakeIcon = createBirdHeroicon('CakeIcon');
export const CalculatorIcon = createBirdHeroicon('CalculatorIcon');
export const CalendarIcon = createBirdHeroicon('CalendarIcon');
export const CameraIcon = createBirdHeroicon('CameraIcon');
export const ChartBarIcon = createBirdHeroicon('ChartBarIcon');
export const ChartPieIcon = createBirdHeroicon('ChartPieIcon');
export const ChatBubbleLeftRightIcon = createBirdHeroicon('ChatBubbleLeftRightIcon');
export const CheckCircleIcon = createBirdHeroicon('CheckCircleIcon');
export const CheckIcon = createBirdHeroicon('CheckIcon');
export const ChevronDownIcon = createBirdHeroicon('ChevronDownIcon');
export const ChevronLeftIcon = createBirdHeroicon('ChevronLeftIcon');
export const ChevronRightIcon = createBirdHeroicon('ChevronRightIcon');
export const ChevronUpIcon = createBirdHeroicon('ChevronUpIcon');
export const CircleStackIcon = createBirdHeroicon('CircleStackIcon');
export const ClipboardDocumentCheckIcon = createBirdHeroicon('ClipboardDocumentCheckIcon');
export const ClipboardDocumentIcon = createBirdHeroicon('ClipboardDocumentIcon');
export const ClipboardDocumentListIcon = createBirdHeroicon('ClipboardDocumentListIcon');
export const ClockIcon = createBirdHeroicon('ClockIcon');
export const CloudArrowDownIcon = createBirdHeroicon('CloudArrowDownIcon');
export const CloudArrowUpIcon = createBirdHeroicon('CloudArrowUpIcon');
export const CloudIcon = createBirdHeroicon('CloudIcon');
export const CodeBracketIcon = createBirdHeroicon('CodeBracketIcon');
export const CogIcon = createBirdHeroicon('CogIcon');
export const CpuChipIcon = createBirdHeroicon('CpuChipIcon');
export const CreditCardIcon = createBirdHeroicon('CreditCardIcon');
export const CubeIcon = createBirdHeroicon('CubeIcon');
export const CurrencyDollarIcon = createBirdHeroicon('CurrencyDollarIcon');
export const DevicePhoneMobileIcon = createBirdHeroicon('DevicePhoneMobileIcon');
export const DocumentArrowDownIcon = createBirdHeroicon('DocumentArrowDownIcon');
export const DocumentChartBarIcon = createBirdHeroicon('DocumentChartBarIcon');
export const DocumentDuplicateIcon = createBirdHeroicon('DocumentDuplicateIcon');
export const DocumentIcon = createBirdHeroicon('DocumentIcon');
export const DocumentTextIcon = createBirdHeroicon('DocumentTextIcon');
export const EllipsisVerticalIcon = createBirdHeroicon('EllipsisVerticalIcon');
export const EnvelopeIcon = createBirdHeroicon('EnvelopeIcon');
export const ExclamationCircleIcon = createBirdHeroicon('ExclamationCircleIcon');
export const ExclamationTriangleIcon = createBirdHeroicon('ExclamationTriangleIcon');
export const EyeIcon = createBirdHeroicon('EyeIcon');
export const EyeSlashIcon = createBirdHeroicon('EyeSlashIcon');
export const FaceSmileIcon = createBirdHeroicon('FaceSmileIcon');
export const FireIcon = createBirdHeroicon('FireIcon');
export const FolderIcon = createBirdHeroicon('FolderIcon');
export const FunnelIcon = createBirdHeroicon('FunnelIcon');
export const GlobeAltIcon = createBirdHeroicon('GlobeAltIcon');
export const HashtagIcon = createBirdHeroicon('HashtagIcon');
export const HeartIcon = createBirdHeroicon('HeartIcon');
export const HomeIcon = createBirdHeroicon('HomeIcon');
export const IdentificationIcon = createBirdHeroicon('IdentificationIcon');
export const InformationCircleIcon = createBirdHeroicon('InformationCircleIcon');
export const LightBulbIcon = createBirdHeroicon('LightBulbIcon');
export const LinkIcon = createBirdHeroicon('LinkIcon');
export const ListBulletIcon = createBirdHeroicon('ListBulletIcon');
export const LockClosedIcon = createBirdHeroicon('LockClosedIcon');
export const MagnifyingGlassIcon = createBirdHeroicon('MagnifyingGlassIcon');
export const MapPinIcon = createBirdHeroicon('MapPinIcon');
export const MinusIcon = createBirdHeroicon('MinusIcon');
export const PaperAirplaneIcon = createBirdHeroicon('PaperAirplaneIcon');
export const PauseIcon = createBirdHeroicon('PauseIcon');
export const PencilIcon = createBirdHeroicon('PencilIcon');
export const PhoneIcon = createBirdHeroicon('PhoneIcon');
export const PhotoIcon = createBirdHeroicon('PhotoIcon');
export const PlayIcon = createBirdHeroicon('PlayIcon');
export const PlusIcon = createBirdHeroicon('PlusIcon');
export const PresentationChartBarIcon = createBirdHeroicon('PresentationChartBarIcon');
export const PresentationChartLineIcon = createBirdHeroicon('PresentationChartLineIcon');
export const PrinterIcon = createBirdHeroicon('PrinterIcon');
export const ReceiptPercentIcon = createBirdHeroicon('ReceiptPercentIcon');
export const RectangleGroupIcon = createBirdHeroicon('RectangleGroupIcon');
export const RocketLaunchIcon = createBirdHeroicon('RocketLaunchIcon');
export const ScaleIcon = createBirdHeroicon('ScaleIcon');
export const ServerStackIcon = createBirdHeroicon('ServerStackIcon');
export const ShareIcon = createBirdHeroicon('ShareIcon');
export const ShieldCheckIcon = createBirdHeroicon('ShieldCheckIcon');
export const ShoppingCartIcon = createBirdHeroicon('ShoppingCartIcon');
export const SparklesIcon = createBirdHeroicon('SparklesIcon');
export const Square2StackIcon = createBirdHeroicon('Square2StackIcon');
export const Squares2X2Icon = createBirdHeroicon('Squares2X2Icon');
export const StarIcon = createBirdHeroicon('StarIcon');
export const SunIcon = createBirdHeroicon('SunIcon');
export const SwatchIcon = createBirdHeroicon('SwatchIcon');
export const TableCellsIcon = createBirdHeroicon('TableCellsIcon');
export const TagIcon = createBirdHeroicon('TagIcon');
export const TrashIcon = createBirdHeroicon('TrashIcon');
export const TrophyIcon = createBirdHeroicon('TrophyIcon');
export const TruckIcon = createBirdHeroicon('TruckIcon');
export const UserCircleIcon = createBirdHeroicon('UserCircleIcon');
export const UserGroupIcon = createBirdHeroicon('UserGroupIcon');
export const UserIcon = createBirdHeroicon('UserIcon');
export const UsersIcon = createBirdHeroicon('UsersIcon');
export const XCircleIcon = createBirdHeroicon('XCircleIcon');
export const XMarkIcon = createBirdHeroicon('XMarkIcon');
